<template>
  <div>
    <!-- 未支付 -->
    <div v-if="!isPay" class="pay-container">
      <p class="pay_title fontColor">
        <img :src="require('@/svg/wechatpay.svg')" />{{
          $t("redpacket.wechatPay")
        }}
      </p>
      <img
        class="pay_img"
        :src="'data:image/jpg;base64,' + creRes.codeUrl"
        width="120"
        height="120"
      />
      <div class="pay_bottom">
        <p>{{ $t("redpacket.scanPay") }}</p>
        <h4>{{ creRes.realAmount/100 }}</h4>
        <p>{{ $t("redpacket.payTips") }}{{(creRes.serviceChargeRatio*100).toFixed(1)}}%</p>
      </div>
    </div>
    <!-- 支付成功 -->
    <div v-else class="pay-container">
      <p class="pay_success pay_title fontColor">
        <img :src="require('@/svg/wechatpay.svg')" width="40" />{{
          $t("redpacket.successPay")
        }}
      </p>
      <p class="pay_realAmount">
        {{ $t("redpacket.paySuccessTips") }}{{ creRes.realAmount / 100 }}{{ $t("redpacket.yuan") }}
      </p>
      <el-button
        type="primary"
        class="button-mini confirm-btn"
        size="mini"
        @click="close"
        >{{ $t("redpacket.confirm") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  pushRoomMessageFunc,
  removeMessageFunc,
} from "@/utils/socketMessageDispose";
export default {
  name: "redPacketPay",
  props: {
    creRes: {
      type: Object,
      default: () => {
        return {
          codeUrl: null,
          redpacketId: "1111111",
        };
      },
    },
  },
  mounted() {
    pushRoomMessageFunc(this.getCvMcRoomMessage);
  },
  beforeDestroy() {
    removeMessageFunc(this.getCvMcRoomMessage);
  },
  data() {
    return {
      isPay: false,
      successData: null,
    };
  },
  methods: {
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
        case 7125: {
          this.disposeCustomMessage_7125(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "redpacketEvent": {
            console.log(requestData);
          }
        }
      }
    },
    disposeCustomMessage_7125(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "redpacketEvent": {
            if (requestData.type == "pay_success") {
              this.isPay = true;
            }
          }
        }
      }
    },
    close() {
      this.$parent.curPage = 0;
      this.$store.commit("SET_SHOW_RED_PACKET", false);
    },
  },
};
</script>

<style scoped lang="scss">
.pay-container {
  margin-bottom: 20px;
}
.pay_title {
  img {
    vertical-align: middle;
    margin-right: 5px;
  }
}
.pay_img {
  margin: 6px 0px;
}
.pay_bottom {
  h4 {
    height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: #ea494b;
    line-height: 33px;
    margin: auto;
  }
  p {
    color: #acb2bf;
    line-height: 17px;
    font-size: 12px;
  }
}
.pay_success {
  margin-top: 30px;
}
.pay_realAmount {
  color: #acb2bf;
  line-height: 17px;
  font-size: 12px;
  margin: 15px 0px 20px 0px;
}
.confirm-btn{
  width: 80px;
  height: 28px;
  border-radius: 6px;
}
</style>